
import { Select, Option } from "element-ui"
import { translate } from "@/plugins/i18n"
export default {
  name: "WareViewSortBox",
  API: ["init"],
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {
        return {
          sortType: 0,
          sortRule: 0
        }
      }
    }
  },
  data() {
    return {
      sortType: "recommended",
      options: [
        {
          value: "recommended",
          label: translate("common.recommended")
        },
        {
          value: "topsales",
          label: translate("common.topSales")
        },
        {
          value: "lowprice",
          label: translate("common.lowestFirst")
        },
        {
          value: "highprice",
          label: translate("common.highestFirst")
        }
      ]
    }
  },

  computed: {},
  watch: {
    defaultValue: {
      handler(val) {
        const { sortKey, sortRule } = val
        let sortType = "recommended"
        switch (sortKey) {
          case 0:
            sortType = "recommended"
            break
          case 1:
            sortType = sortRule === 1 ? "lowprice" : "highprice"
            break
          case 3:
            sortType = "topsales"
            break
          default:
            break
        }
        this.sortType = sortType
      },
      immediate: true
    }
  },

  methods: {
    init() {
      this.sortType = "recommended"
    },
    handleChanged(val) {
      this.$emit("changed", this.getSortParams())
    },
    getSortParams() {
      let sortKey = ""
      let sortRule = 2
      switch (this.sortType) {
        case "recommended":
          sortKey = 0
          sortRule = 0
          break
        case "topsales":
          sortKey = 3
          break
        case "highprice":
          sortKey = 1
          sortRule = 2
          break
        case "lowprice":
          sortKey = 1
          sortRule = 1
          break
        default:
          break
      }
      return {
        sortKey,
        sortRule
      }
    }
  }
}
